import { createRootRoute, createRouter } from "@tanstack/react-router";

import { PageLayout, routes } from "../pages";
import { RouterDevtools } from "./devtools";

const rootRoute = createRootRoute({
  component() {
    return (
      <>
        <PageLayout />
        <RouterDevtools />
      </>
    );
  }
});

const routeTree = rootRoute.addChildren(routes.map((route) => route(rootRoute)));

export const router = createRouter({ routeTree });
